import axios from "axios";

export const vehiculosByCliente = async idCliente => {
  const formattedNic = localStorage.getItem("formattedNic");
  const token = localStorage.getItem("token");

  const userData = {
    nic: formattedNic,
    token: token,
    serialNumberKeyClover: localStorage.getItem("serialNumberKeyClover"),
    idCliente: idCliente,
  };

  try {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/Helper/GetVehiculosByCliente`, userData);
    return response;
  } catch (error) {
    throw error;
  }
};
